import { render } from "./DexProject.vue?vue&type=template&id=b99e4110&scoped=true"
const script = {}

import "./DexProject.vue?vue&type=style&index=0&id=b99e4110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99e4110"]])

export default __exports__